import React from 'react';
import ReactDOM from 'react-dom/client';
import {HelmetProvider} from 'react-helmet-async';
import {RouterProvider} from 'react-router-dom';
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import 'lazysizes';
import {configureSharedAuth} from "@shared/auth/SharedAuth";
import {ToastProvider} from "@shared/components/ui/toast/ToastContext";
import {getRawIdTokenAsString, getRawIdTokenWithGroups} from "./util/AuthUtil";
import {router} from './App';
import './index.css';

configureSharedAuth({getRawIdTokenAsString, getRawIdTokenWithGroups});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <GoogleReCaptchaProvider
            reCaptchaKey={process.env.REACT_APP_CAPTCHA_V3_SITE_KEY!}
            scriptProps={{async: true, defer: true, appendTo: 'body'}}
        >
            <HelmetProvider>
                {/* ToastProvider must wrap the router — useToast() in opt-in forms returns
                    an empty stub without it (showMessage undefined → runtime crash). */}
                <ToastProvider>
                    <RouterProvider router={router}/>
                </ToastProvider>
            </HelmetProvider>
        </GoogleReCaptchaProvider>
    </React.StrictMode>
);
